module.exports = __webpack_public_path__ + "img/back_address_active3.471d95d9.png";